import * as tslib_1 from "tslib";
import { RemoveScroll } from 'react-remove-scroll/UI';
export { AutoFocusInside, MoveFocusInside, InFocusGuard } from 'react-focus-lock/UI';
export var classNames = tslib_1.__assign({}, RemoveScroll.classNames);



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-focus-on/dist/es2015/reExports.js
// module id = 183
// module chunks = 0